var webApiPath = "/api/";
var oDataPath = "/odata/";

export function initialize(module: ng.IModule) {
    module.constant("serviceConfig", {
        "webApiUrl": webApiPath,
        "oDataUrl": oDataPath
    });
}

export class ServiceConfig {
    public static loggedInUser: string;
    public static webApiUrl = webApiPath;
    public static oDataUrl = oDataPath;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/core.constants.ts